module.exports = __webpack_public_path__ + "media/images/pic/banners/book-course-77d5017ca74c2fbccd37a7f90d3b053e.jpeg";